import { render, staticRenderFns } from "./purchases.vue?vue&type=template&id=94c75b94&scoped=true&"
import script from "./purchases.vue?vue&type=script&lang=js&"
export * from "./purchases.vue?vue&type=script&lang=js&"
import style0 from "./purchases.vue?vue&type=style&index=0&id=94c75b94&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94c75b94",
  null
  
)

export default component.exports